import React from 'react';
import { useRegister } from '../hooks/useRegister';
import RegisterForm from './RegisterForm';
import Spinner from '../../../components/ui/Spinner';
import AuthBrandPanel from './AuthBrandPanel';

interface RegisterProps {
  onNavigateToLogin: () => void;
}

const Register: React.FC<RegisterProps> = ({ onNavigateToLogin }) => {
  const {
    name, setName, email, setEmail,
    phone, setPhone, plan, setPlan,
    password, setPassword, confirmPassword, setConfirmPassword,
    isRegistering, error, successMessage,
    inviteDetails, isLoadingInvite, inviteToken, handleRegister,
  } = useRegister({ onNavigateToLogin });

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-background px-s4 py-s6 pb-[max(1.5rem,env(safe-area-inset-bottom))] sm:px-s6 md:px-s8 md:py-s10">
      <article className="flex w-full max-w-5xl flex-col overflow-hidden rounded-xl border border-subtle bg-card shadow-sm md:rounded-2xl md:shadow-md lg:flex-row">
        <section
          className="flex flex-1 flex-col justify-center p-s6 sm:p-s8 lg:p-s10"
          aria-labelledby="register-title"
        >
          <div className="mx-auto w-full max-w-md">
            <div className="mb-s6 flex justify-center lg:hidden">
              <img
                src="/logo%20principal%20140x40.png"
                alt="Adlitics"
                className="h-8 w-auto object-contain dark:hidden"
              />
              <img
                src="/logo%20principal%20dark%20140x40.png"
                alt="Adlitics"
                className="hidden h-8 w-auto object-contain dark:block"
              />
            </div>

            {isLoadingInvite ? (
              <div className="flex justify-center py-s12" role="status" aria-label="Carregando convite">
                <Spinner size="lg" color="primary" />
              </div>
            ) : (
              <RegisterForm
                name={name}
                email={email}
                phone={phone}
                password={password}
                confirmPassword={confirmPassword}
                plan={plan}
                onPlanChange={setPlan}
                isLoading={isRegistering}
                error={error}
                successMessage={successMessage}
                inviteToken={inviteToken}
                inviteDetails={inviteDetails}
                onNameChange={setName}
                onEmailChange={setEmail}
                onPhoneChange={setPhone}
                onPasswordChange={setPassword}
                onConfirmPasswordChange={setConfirmPassword}
                onSubmit={handleRegister}
                onNavigateToLogin={onNavigateToLogin}
              />
            )}
          </div>
        </section>

        <AuthBrandPanel
          tagline="Comece grátis e"
          taglineHighlight="escale no seu ritmo."
          description="Crie sua conta agora e tenha acesso completo ao CRM WhatsApp Adlitics."
        />
      </article>

      <footer className="mt-s6 max-w-md px-s4 text-center md:mt-s8">
        <p className="text-sm text-muted">
          Ao continuar, você concorda com nossos Termos de Serviço e Política de Privacidade.
        </p>
      </footer>
    </main>
  );
};

export default Register;
